window.Page = {

    // Let's launch this thing
    liftoff : () => {
        Site.Products.lazyloadImages();
        Site.Video.updateActiveVideo();
        Page.Gallery.init();
        Page.Related.addBlanks();

        window.addEventListener('resize' , Page.Related.addBlanks)

    },

    // We Need to initiate the slider
    Gallery : {

        // Grab the components
        mainSlider       : document.querySelector('.product-opening-gallery'),
        ambientateSlider : document.querySelector('.product-gallery-ambientate'),
        detailsSlider    : document.querySelector('.product-gallery-details'),
        othersSlider     : document.querySelector('.product-gallery-others'),

        // Init The Slidera
        init : () => {

            if (Page.Gallery.mainSlider) {
                let mainFlickity = new Flickity( Page.Gallery.mainSlider, {    
                    cellAlign            : 'left',
                    contain              : false,
                    contain              : true,
                    wrapAround           : true,
                    prevNextButtons      : true,
                    pageDots             : false,
                    setGallerySize       : true,
                    freeScroll           : false,
                    lazyLoad             : true,
                    imagesLoaded         : true,
                    autoPlay             : 2500,
                    pauseAutoPlayOnHover : true,
                    arrowShape           : { 
                      x0: 25,
                      x1: 60, y1: 35,
                      x2: 65, y2: 30,
                      x3: 35
                    },
                    // Add static click event
                    on : {

                        staticClick : function(event, pointer, cellElement, cellIndex) {

                            let zoomedImage = document.createElement('img')
                            zoomedImage.setAttribute('src' , cellElement.firstElementChild.src)
                            zoomedImage.classList.add('zoomed')
                            zoomedImage.addEventListener('click' , () => {
                                zoomedImage.remove()
                            })
                            document.body.appendChild(zoomedImage)
                        }

                    }
                });
            }

            if (Page.Gallery.ambientateSlider) {
                let ambientateFlickity = new Flickity( Page.Gallery.ambientateSlider, {    
                    cellAlign            : 'left',
                    contain              : false,
                    wrapAround           : true,
                    prevNextButtons      : true,
                    pageDots             : false,
                    setGallerySize       : true,
                    freeScroll           : false,
                    lazyLoad             : true,
                    imagesLoaded         : true,
                    autoPlay             : false,
                    arrowShape           : { 
                      x0: 25,
                      x1: 60, y1: 35,
                      x2: 65, y2: 30,
                      x3: 35
                    },
                    // Add static click event
                    on : {

                        staticClick : function(event, pointer, cellElement, cellIndex) {

                            let zoomedImage = document.createElement('img')
                            zoomedImage.setAttribute('src' , cellElement.src)
                            zoomedImage.classList.add('zoomed')
                            zoomedImage.addEventListener('click' , () => {
                                zoomedImage.remove()
                            })
                            document.body.appendChild(zoomedImage)
                        }

                    }
                });
            }

            if (Page.Gallery.detailsSlider) {
                let detailsFlickity = new Flickity( Page.Gallery.detailsSlider, {    
                    cellAlign       : 'center',
                    contain         : false,
                    wrapAround      : true,
                    prevNextButtons : true,
                    pageDots        : false,
                    setGallerySize  : true,
                    freeScroll      : false,
                    lazyLoad        : true,
                    imagesLoaded    : true,
                    autoPlay        : false,
                    rightToLeft     : false,
                    arrowShape      : { 
                      x0: 25,
                      x1: 60, y1: 35,
                      x2: 65, y2: 30,
                      x3: 35
                    },

                    // Add static click event
                    on : {

                        staticClick : function(event, pointer, cellElement, cellIndex) {

                            let zoomedImage = document.createElement('img')
                            zoomedImage.setAttribute('src' , cellElement.src)
                            zoomedImage.classList.add('zoomed')
                            zoomedImage.addEventListener('click' , () => {
                                zoomedImage.remove()
                            })
                            document.body.appendChild(zoomedImage)
                        }

                    }

                });
            }

            if (Page.Gallery.othersSlider) {
                let othersFlickity = new Flickity( Page.Gallery.othersSlider, {    
                    cellAlign            : 'left',
                    contain              : false,
                    contain              : false,
                    wrapAround           : true,
                    prevNextButtons      : true,
                    pageDots             : false,
                    setGallerySize       : true,
                    freeScroll           : false,
                    lazyLoad             : true,
                    imagesLoaded         : true,
                    autoPlay             : false,
                    arrowShape           : { 
                      x0: 25,
                      x1: 60, y1: 35,
                      x2: 65, y2: 30,
                      x3: 35
                    },
                    // Add static click event
                    on : {

                        staticClick : function(event, pointer, cellElement, cellIndex) {

                            let zoomedImage = document.createElement('img')
                            zoomedImage.setAttribute('src' , cellElement.src)
                            zoomedImage.classList.add('zoomed')
                            zoomedImage.addEventListener('click' , () => {
                                zoomedImage.remove()
                            })
                            document.body.appendChild(zoomedImage)
                        }

                    }
                });
            }

        }

    },

    Related : {

        // Grab all the various grids
        variationGrids   : document.querySelectorAll('.product-variations-thumbs'),
        variationGrid    : document.querySelector('.product-variations-thumbs'),
        variationColumns : 0,

        computeColumns : () => {
            let rawGrids = window.getComputedStyle(Page.Related.variationGrid).getPropertyValue('grid-template-columns').split(" ");
            Page.Related.variationColumns = rawGrids.length;
            return rawGrids.length;
        },

        addBlanks : () => {

            // Calculate the number of columns
            Page.Related.computeColumns()

            Page.Related.variationGrids.forEach(variation => {

                let columns = Math.abs(Page.Related.variationColumns)
                let items   = Math.abs(variation.dataset.items)
                let spacers = Math.abs(variation.dataset.spacers)

                // Calculate the difference between the number of items and the number of columns
                let diff = (items > columns) ? columns - (items % columns) : columns - items
                    diff = (diff == columns) ? 0 : diff

                // if the value is the same do nothing
                if (diff == spacers) return;

                // store the diff in a data attr
                variation.setAttribute('data-spacers' , Math.abs(diff))

                // remove the previous spacers
                variation.querySelectorAll('.product-variation-filler').forEach(spacer => {spacer.remove()})


                // Append the spacers
                for (var i = 0; i < diff; i++) {

                    let spacer  = document.createElement("div");
                        spacer.classList.add('product-variation-filler')

                    variation.appendChild(spacer)
                }

            })

        }

    }

};

Page.liftoff()